//import { TAcList } from './../interfaces';
import { TransactionService } from './transaction.service';
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  ViewChild,
} from '@angular/core';
//import { ModalDirective } from 'ngx-bootstrap/modal'
import { Router, ActivatedRoute } from '@angular/router';
//import { Item } from './../interfaces/ProductItem';
//import {TAcList} from '../../../../common/interfaces';
import {
  TrnMain,
  TrnProd,
  CostCenter,
  VoucherTypeEnum,
} from './../interfaces/TrnMain';
// import { PurchaseInvoiceService } from './purchaseinvoices.service';
// import { ProductInsertComponent } from './ProductInsert';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { MasterRepo } from './../repositories/masterRepo.service';
import { IDivision, Warehouse } from './../interfaces';
// import { AppSettings } from './../AppSettings';
// import { Subscription } from "rxjs/Subscription";
// import { Observable } from "rxjs/Observable";
// import { Subscriber } from "rxjs/Subscriber";
import { SettingService } from './../services';

@Component({
  selector: 'trnmain-branch',
  styleUrls: ['../../pages/Style.css'],
  templateUrl: './trnmain-branch.component.html',
})
export class TrnMainBranchComponent {
  TrnMainForm!: FormGroup;
  AppSettings;
  TrnMainObj: TrnMain = <TrnMain>{};
  divisionList: IDivision[] = [];
  settlementList: any[] = [];
  vchrType = VoucherTypeEnum;
  constructor(
    public masterService: MasterRepo,
    private _trnMainService: TransactionService,
    private _fb: FormBuilder,
    private router: Router,
    private arouter: ActivatedRoute,
    private setting: SettingService
  ) {
    this.AppSettings = this.setting.appSetting;
    this.TrnMainObj = _trnMainService.TrnMainObj;
    if (this.TrnMainObj.VoucherType == 9) {
      this.settlementList = [];
      this.masterService.getSettlementMode().subscribe((data: any) => {
        // console.log({SettlementData:data})
        this.settlementList.push(data);
      });
    }
  }

  ngOnInit() {
    this.masterService.refreshTransactionList();
    this.TrnMainForm = this._fb.group({
      COSTCENTER: ['', Validators.required],
      BILLTOADD: ['', Validators.required],
      WAREHOUSE: ['', Validators.required],
      REMARKS: [''],
      SettleMode: [''],
    });

    if (this.TrnMainObj.Mode == 'VIEW') {
      this.TrnMainForm.get('BILLTOADD')?.disable();
      this.TrnMainForm.get('COSTCENTER')?.disable();
      this.TrnMainForm.get('WAREHOUSE')?.disable();
      this.TrnMainForm.get('REMARKS')?.disable();
      this.TrnMainForm.get('SettleMode')?.disable();
    }

    this.TrnMainForm.valueChanges.subscribe((form) => {
      this._trnMainService.Warehouse = form.WAREHOUSE;
      this.TrnMainObj.BILLTOADD = form.BILLTOADD;
      this.TrnMainObj.COSTCENTER = form.COSTCENTER;
      this.TrnMainObj.REMARKS = form.REMARKS;
    });

    if (this.TrnMainObj.Mode == 'EDIT' || this.TrnMainObj.Mode == 'VIEW') {
      this._trnMainService.loadDataObservable.subscribe((data: any) => {
        try {
          console.log('trnmain-Branch@', data);
          var warehouse: string;
          if (data.ProdList[0] != null) {
            warehouse = data.ProdList[0].WAREHOUSE;
          } else {
            warehouse = '';
          }
          if (this.TrnMainObj.VoucherType == 9) {
            this.settlementList = [];
            this.masterService.getSettlementMode().subscribe(
              (data: any) => {
                this.settlementList.push(data);
              },
              (error: any) => {
                alert(error);
              },
              () => {
                //  console.log("settlecheck",this.settlementList,data.TRNMODE);
                this.TrnMainForm.patchValue({
                  SettleMode: this.settlementList.filter(
                    (d) => d.DESCRIPTION == data.TRNMODE
                  )[0],
                });
                this.SettlementChange();
              }
            );
          }
          //  console.log("A",this.settlementList)
          //  let c =this.settlementList.filter(d=>d.DESCRIPTION== data.TRNMODE);
          //  console.log("C#",c)

          this.TrnMainForm.patchValue({
            COSTCENTER: data.COSTCENTER,
            BILLTOADD: data.BILLTOADD,
            REMARKS: data.REMARKS,
            WAREHOUSE: warehouse,
            // SettleMode:c,
          });
        } catch (e) {
          console.log({ errorOnLoad: e });
        }
      });
    }
  }

  changeBranch(value: any) {
    console.log(this.TrnMainObj.DIVISION);
    this.masterService.divisionList$.subscribe((data: any) => {
      this.divisionList = data;
    });
    if (this.TrnMainForm.get('BILLTOADD')?.value == this.TrnMainObj.DIVISION) {
      // this.divisionList.splice(this.divisionList.findIndex(d =>d.INITIAL == this.TrnMainObj.DIVISION), 1);
      var division =
        this.divisionList[
          this.divisionList.findIndex(
            (d) => d.INITIAL == this.TrnMainObj.DIVISION
          )
        ].NAME;
      alert(
        '(' +
          division +
          ') branch has already been selected in division above, please select a different branch.'
      );
      this.TrnMainForm.patchValue({
        BILLTOADD: '',
      });
    }
  }

  // private resolevError(error: Error) {
  //     if (error.message == 'The ConnectionString property has not been initialized.') {
  //         this.router.navigate(["/login", { returnUrl: this.router.url }]);
  //     }
  //     else {
  //         alert(error.message);
  //     }
  // }
  SettlementChange() {
    //   console.log("settleChece",this.TrnMainForm.value.SettleMode.DECREASE);
    this._trnMainService.SettlementNo =
      this.TrnMainForm.value.SettleMode.DECREASE;
    this._trnMainService.TrnMainObj.TRNMODE =
      this.TrnMainForm.value.SettleMode.DESCRIPTION;
  }

  formValidCheck = (): boolean => {
    // console.log({ warehouse: this.warehouse, prodlist: this.TrnMainObj.AdditionProdList, trnac: this.TrnMainObj.TRNAC });
    if (
      this._trnMainService.Warehouse == undefined ||
      this._trnMainService.Warehouse == ''
    ) {
      return false;
    }
    if (this.TrnMainObj.ProdList == undefined) {
      return false;
    } else {
      if (this.TrnMainObj.ProdList.length < 1) {
        return false;
      }
    }
    // if (this.TrnMainObj.TRNAC == undefined || this.TrnMainObj.TRNAC == '') {
    //     return false;
    // }

    return true;
  };
}
